import { Routes, Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { Loader, Center } from '@mantine/core';

// Lazy load pages for better performance
const HomePage = lazy(() => import('./pages/HomePage'));
const RestaurantPage = lazy(() => import('./pages/RestaurantPage'));
const MenuPage = lazy(() => import('./pages/MenuPage'));
const SearchPage = lazy(() => import('./pages/SearchPage'));
const CartPage = lazy(() => import('./pages/CartPage'));
const CheckoutPage = lazy(() => import('./pages/CheckoutPage'));
const OrderTrackingPage = lazy(() => import('./pages/OrderTrackingPage'));
const AccountPage = lazy(() => import('./pages/AccountPage'));
const LoginPage = lazy(() => import('./pages/LoginPage'));
const CmsPage = lazy(() => import('./pages/CmsPage'));
const BlogPostPage = lazy(() => import('./pages/BlogPostPage'));

function LoadingFallback() {
  return (
    <Center h="100vh">
      <Loader color="orange" size="lg" type="dots" />
    </Center>
  );
}

function App() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/restaurant/:slug" element={<RestaurantPage />} />
        <Route path="/restaurant/:slug/menu" element={<MenuPage />} />
        <Route path="/restaurant/:slug/page/:pageSlug" element={<CmsPage />} />
        <Route path="/restaurant/:slug/blog/:postSlug" element={<BlogPostPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/track/:orderId" element={<OrderTrackingPage />} />

        {/* Auth routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/account/*" element={<AccountPage />} />
      </Routes>
    </Suspense>
  );
}

export default App;
